export default function guest({ next, router}) {
    /*
        Si existe el usuario en el storage lo manda al inicio
     */
    if (
        localStorage.getItem('user') && localStorage.getItem('user').includes('id')
    ) {
        const { core_role_code } = JSON.parse(localStorage.getItem('user'))
        if (core_role_code === 'business-partner') return router.push({ name: 'AllDemands' })
        return router.push({ name: 'HomeOnboarding' })
    }

    return next()
}